<template>
    <v-data-table
        :headers="headers"
        :items="users"
        :loading="loading"
        no-data-text="No users found"
        no-results-text="No users found"
        loading-text="Loading users"
        class="elevation-0 bg-grey-lighten-5"
        hide-default-footer
    >
        <template v-slot:item.actions="{ item }">
            <v-row justify="center" class="min-width-115 action-buttons">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn
                            @click="openUser(item)"
                            @click.middle.exact="openUser(item)"
                            small
                            color="primary"
                            icon
                            v-on="on"
                        >
                            <v-icon>mdi-open-in-new</v-icon>
                        </v-btn>
                    </template>
                    <span>Details</span>
                </v-tooltip>
            </v-row>
        </template>
    </v-data-table>
</template>
<script>
export default {
    name: 'CompaniesListStationLocationUser',
    props: {
        users: {type: Array, required: true},
    },
    data() {
        return {
            loading: true,
            expanded: [],
            headers: [
                {
                    text: 'ID',
                    align: 'start',
                    sortable: false,
                    value: 'id',
                },
                {
                    text: 'Name',
                    align: 'start',
                    sortable: false,
                    value: 'name',
                },
                {
                    text: 'Email',
                    align: 'start',
                    sortable: false,
                    value: 'email',
                },
                {
                    text: 'Role',
                    align: 'start',
                    sortable: false,
                    value: 'role',
                },
                {
                    text: '',
                    align: 'end',
                    sortable: false,
                    value: 'actions',
                },
            ],
        };
    },
    mounted() {
        this.loading = false;
    },
    methods: {
        openUser(user) {
            const path = this.$router.resolve({
                name: 'user-view',
                params: {id: user.id},
            });
            return window.open(path.href, '_blank');
        },
    },
};
</script>


<style scoped>
.bg-grey-lighten-5 {
    background-color: #d3d3d3;
    border-radius: 0;
}
</style>